<template>
	<div>
		<ol class="breadcrumb float-xl-end">
			<li class="breadcrumb-item"><router-link to="/base-data/locks">Lakatok</router-link></li>
			<li class="breadcrumb-item active">{{lock.name}}</li>
		</ol>
		<h1 class="page-header">Lakat szerkesztése</h1>
		<Loading v-if="lock === false" title="Szekrény betöltése"></Loading>
		<NoRecords v-if="lock.notfound" main_icon="fas fa-user-lock" value="false" title="Nem található a szekrény" subtitle="Menjen vissza a csoport lakat szekrényekhez!"></NoRecords>
		<div class="row" v-if="lock !== false && !lock.notfound">
			<div class="col-md-6">
				<panel title="Adatok" noButton="true">
					<form @submit.prevent="updateLock()">
						<div class="form-group">
							<label class="form-label" for="name">Megnevezés</label>
							<input type="text" v-model="lock.name" required class="form-control">
							<div class="bg-danger" v-if="errors.name">{{error.name[0]}}</div>
						</div>
						<div class="text-end mt-2">
							<button class="btn btn-primary"><i class="fa fa-save"></i> Mentés</button>
						</div>
					</form>
				</panel>
			</div>
		</div>
	</div>
</template>

<script>
	import Loading from '../../components/Loading';
	import NoRecords from '../../components/NoRecords';
	import Lock from "../../apis/Lock";

	export default {
		components: {
			Loading, NoRecords
		},
		data() {
			return {
				lock:false,
				errors: []
			}
		},
		created() {
			Lock.show(this.$route.params.id)
			.then(response => {
				this.$set(this,'lock',response.data);
			}).catch(() => {
				this.$set(this,'lock',{name:'ismeretlen', notfound:true});
			});
		},
		methods: {
			updateLock(){
				Lock.update(this.$route.params.id,this.lock)
				.then(() => {
					console.log('siker');
				}).catch(error => {
					if(error.response.data.errors){
						this.errors = error.response.data.errors;
					}
				});
			}
		},
	}
</script>

<style>
	
</style>